<template>
    <div class="main-content">
        <div class="background">
            <div class="container">
                <div class="panel mobile-app">
                    
                  <div class="title">Ainak AR App</div>
                  <div class="video">
                    <iframe src="https://www.youtube.com/embed/6DwxWnbgr6c" 
                    frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                    </iframe>
                  </div>
                  <br><br>
                  <p>Download Link:</p>
                  <center>
                    <a class="button" target="_blank" href="https://play.google.com/store/apps/details?id=com.Ainak.AinakARApp">
                            <a> <i class="fa fa-android" aria-hidden="true"></i> Android Play store</a>
                    </a> 
                    <a class="button" target="_blank" href="https://testflight.apple.com/join/IWYHzAah">
                            <a> <i class="fa fa-apple" aria-hidden="true"></i> iOS (Beta) Testflight App</a>
                    </a>
                  </center>
                
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeContent",
        data() {
            return {
            }
        },
        components: {
        },
        computed: {
            selectTab(){
                return this.$store.getters.getUploadPage;
            }
        },
        methods:{
            tabChanged(event){
                console.log("I am changed!",event);
                this.$store.dispatch('setCurrentTab', event)
            }
        }
    };
</script>

<style lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    %top-padding-width-height {
        width: 100%;
        height: 100%;
        top: 0;
    }
    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .main-content {
        grid-area: home-content;
        background-color: $bg-color;
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "home-content-header" "home-content-models";
        grid-template-rows: 10%  90%;
        grid-template-columns: 1fr;
        overflow: hidden;
    }


.background {
  padding: 0 25px 25px;
//   position: relative;
  width: 100%;
}

// .background::after {
//   content: '';
// //   background: $primary-color;
// //   background: -moz-linear-gradient(top, #60a9ff 0%, #4394f4 100%);
// //   background: -webkit-linear-gradient(top, #60a9ff 0%,#4394f4 100%);
// //   background: linear-gradient(to bottom, #60a9ff 0%,#4394f4 100%);
// //   filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#60a9ff', endColorstr='#4394f4',GradientType=0 );
//   height: 350px;
//   left: 0;
// //   position: absolute;
//   top: 0;
//   width: 100%;
//   z-index: 1;
// }

@media (min-width: 900px) {
  .background {
    padding: 20px 0 25px;
  }
}

.container {
  max-width: 960px;
  width: 100%;
}

.panel {
  background-color: #fff;
  border-radius: 10px;
  padding: 15px 25px;
  position: relative;
  width: 100%;
  overflow: auto;
  max-height: 80vh;
  box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.08), 0px 20px 31px 3px rgba(0, 0, 0, 0.09), 0px 8px 20px 7px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  scroll-behavior: auto;

  .title {
    color: #555;
    margin: 20px;
    padding: 20px;
    font-size: 24px;
  }
  .video{
      width: 100%;
    iframe{
      width:768px;
      height:432px;
    }
     
    @media (max-width: 900px) {
      iframe{
        width:384px;
        height:216px;
      }
    }
  }
  p{
    text-align: left;
    margin: 0 0 5px 5px;
    color: #555;
    font-size: 18px;
    font-weight: 700;
  }
  center{    
    .button{
      margin: 5px;
      text-decoration: none;
        color: $primary-color;
        width: 40%;
        font-weight: 700;
        border: 1px solid #555;

        i{
          color:#333;
          margin-right: 20px;
        }
    }
    @media (max-width: 900px) {
      .button{
        width: 100%;
      }
    }

  }
  
    center :hover{
        color: #fff;
        background-color: $primary-color;
        border: 1px solid $primary-color;
        i{
          color:#fff;
        }
    }
}


</style>
